module.exports = __webpack_public_path__ + "static/fish.5d532a5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/schools/fish.jpg
// module id = 504
// module chunks = 159792248505240